import { render } from "./CardIcon.vue?vue&type=template&id=1f769480&scoped=true&ts=true"
import script from "./CardIcon.vue?vue&type=script&lang=ts"
export * from "./CardIcon.vue?vue&type=script&lang=ts"

import "./CardIcon.vue?vue&type=style&index=0&id=1f769480&lang=less&scoped=true"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f769480"]])

export default __exports__